module.exports = __webpack_public_path__ + "static/media/MONEDERO_ALT.4e1946a4.svg";